module.exports = __webpack_public_path__ + "static/img/img_title_it.e3922a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_it.png
// module id = gkcv
// module chunks = 1